import React from "react";
import {panelSodimacResources} from "../endpoints";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import {Grid} from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import {KeyboardDatePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import es from "date-fns/locale/es";
import DateFnsUtils from "@date-io/date-fns";
class DialogGenerarExcelPanel extends React.Component{
    constructor(props) {
        super(props);
        this.state={
            open : true,
            progress : false,
            fecha_inicio: new Date(),
            fecha_termino: new Date(),
            fecha: new Date(),
            tipo: this.props.tipo,
        }
    }

    handleFechaInicioChange = (date) => {
        this.setState({fecha_inicio: date});
    }

    handleFecha = (date) => {
        this.setState({fecha: date});
    }
    handleFechaTerminoChange = (date) => {
        this.setState({fecha_termino: date});
    }

    generarExcel =  () =>{
        this.setState({progress: true})
        if(this.state.tipo !== 'validacion'){
            let fecha_termino = this.state.fecha_termino.toLocaleDateString().split("-").reverse().join("-")
            let fecha_inicio = this.state.fecha_inicio.toLocaleDateString().split("-").reverse().join("-")

            panelSodimacResources.generarExcel(fecha_inicio, fecha_termino).then(async response => {
                if (response) {
                    return await response.json()
                }
            }).then( result => {
                if(result.message){
                    this.setState({progress:false})
                    this.props.refrescar(result.message,result.severity)
                }
                else{
                    throw new Error('Something went wrong ...');
                }
            }).catch(error=> {
                console.error(error);
                this.setState({progress:false})
                this.props.refrescar("Ha ocurrido un error inesperado","error")
            });
        }
        else{
            let fecha = this.state.fecha.toLocaleDateString().split("-").reverse().join("-")

            panelSodimacResources.generarExcelValidacion(fecha).then(async response => {
                if (response) {
                    return await response.json()
                }
            }).then( result => {
                if(result.message){
                    this.setState({progress:false})
                    this.props.refrescar(result.message,result.severity)
                }
                else{
                    throw new Error('Something went wrong ...');
                }
            }).catch(error=> {
                console.error(error);
                this.setState({progress:false})
                this.props.refrescar("Ha ocurrido un error inesperado","error")
            });
        }
    }

    UNSAFE_componentWillMount() {

    }


    render() {
        return(
         <div>
             {this.state.tipo !== 'validacion' &&
            <Dialog
                open={this.state.open}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">Ingrese rango de fechas</DialogTitle>
                <DialogContent style={{display:'inline-grid'}}>
                    <MuiPickersUtilsProvider locale={es} utils={DateFnsUtils}>
                        <Grid container>
                            <KeyboardDatePicker
                                id = 'fecha_inicio'
                                disableToolbar
                                variant="inline"
                                format="dd/MM/yyyy"
                                margin="normal"
                                name={"fecha_inicio"}
                                label="Fecha inicio"
                                value={this.state.fecha_inicio}
                                onChange={this.handleFechaInicioChange}
                                KeyboardButtonProps={{
                                    'aria-label': 'change date',
                                }}
                            />
                        </Grid>
                    </MuiPickersUtilsProvider>
                    <MuiPickersUtilsProvider locale={es} utils={DateFnsUtils}>
                        <Grid container>
                            <KeyboardDatePicker
                                id = 'fecha_termino'
                                disableToolbar
                                variant="inline"
                                format="dd/MM/yyyy"
                                margin="normal"
                                name={"fecha_termino"}
                                label="Fecha termino"
                                value={this.state.fecha_termino}
                                onChange={this.handleFechaTerminoChange}
                                KeyboardButtonProps={{
                                    'aria-label': 'change date',
                                }}
                            />
                        </Grid>
                    </MuiPickersUtilsProvider>
                    {this.state.progress? <CircularProgress style={{marginTop: '10px',justifySelf: 'center'}}/>: null}
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" color="secondary" onClick={this.props.handleClose}>
                        Cancelar
                    </Button>
                    <Button onClick={this.generarExcel} variant="contained" color="primary" >
                        Exportar
                    </Button>
                </DialogActions>
            </Dialog>}
             {this.state.tipo === 'validacion' &&
                 <Dialog
                     open={this.state.open}
                     aria-labelledby="alert-dialog-title"
                     aria-describedby="alert-dialog-description">
                     <DialogTitle id="alert-dialog-title">Ingrese fecha</DialogTitle>
                     <DialogContent style={{display:'inline-grid'}}>
                         <MuiPickersUtilsProvider locale={es} utils={DateFnsUtils}>
                             <Grid container>
                                 <KeyboardDatePicker
                                     id = 'fecha_inicio'
                                     disableToolbar
                                     variant="inline"
                                     format="dd/MM/yyyy"
                                     margin="normal"
                                     name={"fecha"}
                                     label="Fecha"
                                     value={this.state.fecha}
                                     onChange={this.handleFecha}
                                     KeyboardButtonProps={{
                                         'aria-label': 'change date',
                                     }}
                                 />
                             </Grid>
                         </MuiPickersUtilsProvider>
                         {this.state.progress? <CircularProgress style={{marginTop: '10px',justifySelf: 'center'}}/>: null}
                     </DialogContent>
                     <DialogActions>
                         <Button variant="contained" color="secondary" onClick={this.props.handleClose}>
                             Cancelar
                         </Button>
                         <Button onClick={this.generarExcel} variant="contained" color="primary" >
                             Exportar
                         </Button>
                     </DialogActions>
                 </Dialog>}
         </div>
        )
    }
}

export default DialogGenerarExcelPanel;